/**
 * Botão "Baixar Excel" do Fluxo (#30). Gera o .xlsx do DADO QUE A TELA JÁ TEM
 * (builder puro `buildFluxoExport` sobre as linhas do `computeRows30d`) — bate
 * o gráfico/tabela por construção. Desabilitado sem dado REAL (nunca exporta
 * mock — #246: estado desabilitado com motivo, não botão morto).
 */
import { useState } from "react";
import { Download } from "lucide-react";
import { getFluxoComposicao } from "../../api/client";
import { buildAoa } from "../ui/ExportDropdown";
import {
  buildFluxoExport,
  montarAbasComposicao,
  type ComposicaoOpts,
  type FluxoExportInput,
} from "./fluxoExport";

export function FluxoExcelButton({
  input,
  motivo,
}: {
  input: FluxoExportInput | null;
  /** Motivo do desabilitado (gate anti-mock F-30A/B/C) — vira o title. */
  motivo?: string | null;
}) {
  // Habilitação: builder SEM composição (a composição é buscada no clique).
  const built = input ? buildFluxoExport(input) : null;
  const [gerando, setGerando] = useState(false);

  async function baixar() {
    if (!built || !input || gerando) return;
    setGerando(true);
    try {
      // #30b: abas de detalhe vêm do backend (mesma base das séries). Falha
      // NÃO bloqueia o agregado — exporta sem detalhe com nota honesta.
      let composicao: ComposicaoOpts = {
        nota: "Composição por lançamento: indisponível (erro ao buscar o detalhe).",
      };
      try {
        const comp = await getFluxoComposicao({ dias: input.dias, hoje: input.hojeIso });
        composicao = montarAbasComposicao(comp, input.fonteSaidas);
      } catch {
        // mantém a nota de indisponível — nunca detalhe inventado
      }
      const full = buildFluxoExport(input, composicao)!;
      const XLSX = await import("xlsx");
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.aoa_to_sheet(buildAoa(full.mainColumns, full.mainRows)),
        full.sheetName,
      );
      for (const s of full.extraSheets) {
        XLSX.utils.book_append_sheet(
          wb,
          XLSX.utils.aoa_to_sheet(buildAoa(s.columns, s.rows)),
          s.name,
        );
      }
      XLSX.writeFile(wb, `${full.filename}.xlsx`);
    } finally {
      setGerando(false);
    }
  }

  return (
    <button
      type="button"
      data-testid="fluxo-excel-btn"
      onClick={baixar}
      disabled={!built || gerando}
      title={
        built
          ? "Baixa o fluxo da janela atual em .xlsx (o que está na tela)"
          : motivo ?? "aguardando dado real do fluxo (não exporta mock)"
      }
      className={
        "flex items-center gap-2 px-3 py-1.5 text-xs rounded-md border transition-colors " +
        (built
          ? "text-white/70 border-white/10 hover:bg-white/5 hover:text-white"
          : "text-white/25 border-white/5 cursor-not-allowed")
      }
    >
      <Download size={14} />
      {gerando ? "Gerando…" : "Baixar Excel"}
    </button>
  );
}
